<template>
  <section class="evento-lux">
    <article ref="card2" class="card" aria-label="Celebration">
      <img class="icono" src="@/assets/10.avif" alt="" />

      <h3 class="titulo-script">Celebration</h3>

      <p class="nota-mismo-lugar">
        The religious ceremony and celebration will take place at the same venue
      </p>

      <p class="hora">7:00 PM</p>
      <p class="lugar">Grand Venue
</p>
      <p class="direccion">
      16618 Clay Rd ste 480, Houston, Texas
      </p>

      <a
        ref="btn2"
        class="btn-rosa"
        href="https://maps.app.goo.gl/UafLcX8vbZmYR69U7"
        target="_blank"
        rel="noopener"
      >
        How to get there?
        <span class="sheen" aria-hidden="true"></span>
      </a>
    </article>
        <img src="@/assets/regal.png" class="corona-bottom" alt="crown" />

  </section>

  <!-- Escena final -->
  
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const card2 = ref(null)
    const btn2 = ref(null)

    const animCard = (cardEl, btnEl) => {
      const $ = gsap.utils.selector(cardEl)

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 88%',
          end: 'bottom 65%',
          scrub: 0.25
        },
        defaults: { ease: 'power2.out' }
      })

      tl.from(cardEl, {
          opacity: 0,
          y: 22,
          filter: 'blur(4px)',
          duration: 0.4
        })
        .from($('.icono'), {
          opacity: 0,
          y: 16,
          duration: 0.3
        }, '-=0.2')
        .from($('.titulo-script'), {
          opacity: 0,
          y: 18,
          duration: 0.35
        })
        .from($('.nota-mismo-lugar'), {
          opacity: 0,
          y: 10,
          duration: 0.25
        }, '-=0.25')
        .from($('.hora'), {
          opacity: 0,
          x: -20,
          duration: 0.3
        }, '-=0.2')
        .from($('.lugar'), {
          opacity: 0,
          x: 20,
          duration: 0.3
        }, '-=0.2')
        .from($('.direccion'), {
          opacity: 0,
          y: 12,
          duration: 0.3
        }, '-=0.15')
        .from(btnEl, {
          opacity: 0,
          y: 12,
          scale: 0.97,
          duration: 0.3
        }, '-=0.1')

      // Sheen del botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 88%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 0.6 }
          )
        }
      })
    }

    onMounted(() => {
      animCard(card2.value, btn2.value)
    })

    return { card2, btn2 }
  }
}
</script>

<style scoped>
/* ==================== BASE ELEGANTE ==================== */
:root{
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux{
  min-height: 50%;
  padding: 28px 18px 64px;
 
  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card{
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;
  background-color: transparent;
  padding: 24px 20px 8px;
  text-align: center;
}

/* Icono discreto */
.icono{
  width: 52px; height:auto; display:block; margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .92;
}

/* Tipos (usa tus fuentes ya cargadas) */
.titulo-script{
  font-family: 'britishgruesa', cursive;
  font-weight: 400;
  font-size: 56px;
  color: var(--tinta);
  letter-spacing: .4px;
  margin: 4px 0 8px;
}
.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 6px;
}
.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
}
.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 90%;
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 14px;
  background: #8fbbdf;
  color: #1f1f1f;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  box-shadow: 0 8px 16px rgba(0,0,0,.12), inset 0 1px 0 rgba(255,255,255,.7);
  transition: transform .16s ease, box-shadow .16s ease, filter .16s ease;
  border: 1px solid rgba(0,0,0,.06);
  z-index: 0;
}
.btn-rosa:hover{
  transform: translateY(-1px);
  box-shadow: 0 12px 20px rgba(0,0,0,.16), inset 0 1px 0 rgba(255,255,255,.8);
  filter: brightness(1.03);
}
.btn-rosa .sheen{
  position: absolute; top: -30%; left: -30%;
  width: 60%; height: 160%; transform: rotate(20deg);
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.55) 50%, rgba(255,255,255,0) 100%);
  pointer-events: none; mix-blend-mode: screen; opacity: 0;
}

/* ==================== LÍNEA VERTICAL ==================== */
.linea-wrapper{ height: 64px; display:flex; justify-content:center; align-items:flex-start; margin-top: 12px; }
.linea{
  width: 1px; height: 64px;
  background: linear-gradient(to bottom, #171717, #2a2929);
  transform: scaleY(1);
  will-change: transform;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px){
  .titulo-script{ font-size: 32px; }
  .hora{ font-size: 22px; }
  .lugar{ font-size: 16px; }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce){
  *{ transition: none !important; animation: none !important; }
}








/* ===== Escena final (degradado + flores) ===== */
.lux-escena-final{
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 8px;  
  margin-bottom: -30px;          /* pequeño respiro respecto a la tarjeta */
  overflow: visible;
}

.lux-degradado{
  width: 100%;
  height: 180px;              /* ajusta la altura del degradado a tu gusto */
  background: linear-gradient(
    to top,
    #f6d5e5 0%,               /* rosa baby base */
    rgba(213, 229, 246, 0.85) 35%,
    rgba(246,213,229,0.35) 65%,
    rgba(246,213,229,0) 100%
  );
}

/* Flores pegadas al borde inferior con ligera sombra */
.lux-flores{
  position: absolute;
  bottom: 22px;               /* -2 para tocar el límite inferior visualmente */
  left: 50%;
  transform: translateX(-50%);
  width: min(760px, 90%);    /* ancho generoso estilo portada */
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0,0,0,.08));
  opacity: 0.98;
}
.nota-mismo-lugar{
  font-family: 'padres', serif;
  font-size: 13px;
  color: #6a6a6a;
  font-style: italic;
  margin: 4px 0 10px;
  letter-spacing: 0.04em;
}
.corona-bottom{
  margin-top: -50px;
  width: 150px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 10px rgba(0,0,0,.15));
}

</style>
